import { useSessionValue } from '@portal/appLayer/auth';
import { useQuery } from '@tanstack/react-query';
import { GetCustomerMetafieldsResponse } from 'api/members/get-customer-metafields/types';
import { apiRoutes } from 'constants/routes';
import { useInternalApiRequest } from 'shared/hooks/useInternalApiRequest';
import { useStoreValue } from 'state/hooks/useStore';
import { getQueryKeyForInternal } from 'state/utils/getQueryKeyForInternal';
import { requestErrors } from '../constants';

export function getQueryKeyForGetCustomerMetafields(store: string, customerId?: number | string) {
  return getQueryKeyForInternal({
    keys: ['customerMetafields', store, customerId ? `${customerId}` : '']
  });
}

export const useQueryGetCustomerMetafields = () => {
  const store = useStoreValue();
  const session = useSessionValue();
  const request = useInternalApiRequest();
  const customerId = session?.customer.id;

  const data = useQuery({
    queryFn: async () => {
      if (!customerId) throw new Error(requestErrors.CUSTOMER_ID_NOT_DEFINED);

      return request<GetCustomerMetafieldsResponse>({
        method: 'GET',
        url: apiRoutes.members.getCustomerMetafields({ store }, { customerId: String(customerId) })
      });
    },
    queryKey: getQueryKeyForGetCustomerMetafields(store, customerId)
  });

  return { ...data };
};
